import React, { useEffect, useState } from "react";
import { getAPIUrlBM } from "../../../../utils/config";
import Get from "../../../../Apis/backlink/Get";
import "./style.css";
import CrossIcon from "../../Assets/CrossIcon";

function SubscriberDropDown({ getSubsList, curSelectedSubs, pageName }) {
  const sweet = window.sweet;
  const [subs, setSubs] = useState();
  const [selectedSubs, setSelectedSubs] = useState(curSelectedSubs);
  const [checkedState, setCheckedState] = useState();
  const [newSub, setNewSub] = useState();
  const [newSubList, setNewSubList] = useState([]);
  const [newSubCheckedState, setNewSubCheckedState] = useState([]);
  const [toggleSubsList, setToggleSubsList] = useState(false);
  const [error, setError] = useState({
    email: false,
  });
  const getSubs = async () => {
    try {
      const url = getAPIUrlBM();
      const res = await Get(url + "/getsubscriber");
  
      // stating state of check box according to it presence in the curSelectedSubs
      var existingMailArrState = [];
      res?.data?.forEach((mail) => {
        var existingMail = curSelectedSubs.includes(mail.email);
        existingMailArrState.push(existingMail);
      });
      setCheckedState(existingMailArrState);
  
      setSubs(res.data);
      
    } catch (error) {
      console.log(error)
    }
  };
  useEffect(() => {
    getSubs();
  }, []);

  const handleNewSubOnChange = async (position) => {
    try {
      const updateNewSubCheckedState = await newSubCheckedState.map(
        (item, index) => {
          if (index === position) {
            if (!newSubCheckedState[index]) {
              setSelectedSubs([...selectedSubs, newSubList[index]]);
            } else {
              var arr = selectedSubs.filter((item) => item !== newSubList[index]);
              setSelectedSubs(arr);
            }
          }
          return index === position ? !item : item;
        },
      );
      setNewSubCheckedState(updateNewSubCheckedState);
      
    } catch (error) {
      console.log(error)
    }
  };

  const handleExistingSubOnChange = async (position) => {
    try {
      const updatedCheckedState = await checkedState.map((item, index) => {
        if (index === position) {
          if (!checkedState[index]) {
            setSelectedSubs([...selectedSubs, subs[index].email]);
          } else {
            var arr = selectedSubs.filter(
              (item) => item !== subs[position].email,
            );
            setSelectedSubs(arr);
          }
        }
        return index === position ? !item : item;
      });
      setCheckedState(updatedCheckedState);
      
    } catch (error) {
      console.log(error)
    }
  };

  const handleNewSub = () => {
    if (newSub?.length === 0) {
      setError({ ...error, email: true });
      return;
    }
    var new_Sub = newSub.trim();
    new_Sub = new_Sub.toLowerCase();
    if (newSubList.find((val) => val === new_Sub) !== undefined) {
      sweet({
        title: "OOPS!",
        text: "You already added user.",
        icon: "info",
      });
      return;
    } else if (
      subs?.find((val) => val.email.trim() === new_Sub) !== undefined
    ) {
      sweet({
        title: "OOPS!",
        text: "User already exists in Subscribers Drop down List",
        icon: "info",
      });
      return;
    }
    setNewSubCheckedState([...newSubCheckedState, true]);
    setSelectedSubs([...selectedSubs, new_Sub]);
    setNewSubList([...newSubList, new_Sub]);
    setNewSub("");
  };

  const emailValidation = (e) => {
    var ch = e.target.value;
    if (ch.length === 0) {
      setNewSub(e.target.value);
      setError({ ...error, email: false });
      return;
    }
    setNewSub(e.target.value);
    var re = /\S+@\S+\.\S+/;
    var valid = re.test(e.target.value);
    if (!valid) setError({ ...error, email: true });
    else setError({ ...error, email: false });
  };

  useEffect(() => {
    getSubsList(selectedSubs);
  }, [selectedSubs]);

  return (
    <div className="subcriberConatiner">
      <div>
        <input
          className={error.email ? "error inputSub" : "normal inputSub"}
          type="email"
          required
          value={newSub}
          placeholder="Enter new Email"
          onChange={emailValidation}
          onClick={() => setToggleSubsList(true)}
        />
        <button
          onClick={handleNewSub}
          className={
            error.email ? "disabledButton subButton" : "activeButton subButton"
          }
          disabled={error.email}
        >
          Add New
        </button>
        {error.email ? <p className="errMessage"> Invalid Email</p> : null}

        <div className="flexDiv">
          <div className="selectedSubs" onClick={() => setToggleSubsList(true)}>
            {selectedSubs?.map((item, val) => (
              <div className="block-Subs" key={val}>
                {item}
              </div>
            ))}
          </div>
          {/* <button
            className="activeButton subButton"
            onClick={() => setToggleSubsList(!toggleSubsList)}
            >
            {toggleSubsList ? "Hide" : "Show"}
          </button> */}
        </div>
      </div>

      <div>
        {toggleSubsList ? (
          <>
            <div
              className="dropdownOfList"
              onClick={() => setToggleSubsList(false)}
            ></div>

            <ul
              className={
                pageName === "editPage"
                  ? "subsComponentButtom"
                  : "subsComponentTop"
              }
            >
              <div
                className="fixed-top-right"
                onClick={() => setToggleSubsList(false)}
              >
                <CrossIcon />
              </div>
              {newSubList?.length === 0 && subs?.length === 0 ? (
                <p style={{ textAlign: "center", marginTop: "10px" }}>
                  Subscribers List is Empty.
                </p>
              ) : (
                <div>
                  {newSubList?.length ? (
                    <>
                      <p className="listTitle">New Subscribers</p>
                      {newSubList?.map((mail, index) => (
                        <li
                          value={mail}
                          key={index}
                          onClick={() => {
                            handleNewSubOnChange(index);
                          }}
                        >
                          <div
                            className="subsItem"
                            id={`custom-checkbox-Item-${index}`}
                          >
                            <label
                              htmlFor={`custom-checkbox-${index}`}
                              className="subsLabel"
                            >
                              {mail}
                            </label>
                            <input
                              type="checkbox"
                              id={`custom-checkbox-${index}`}
                              name={mail}
                              value={mail}
                              defaultChecked
                              checked={newSubCheckedState[index]}
                            />
                          </div>
                        </li>
                      ))}
                      <hr />
                    </>
                  ) : null}
                  <p className="listTitle">Exisiting Subscribers</p>
                  {subs?.map((mail, index) => (
                    <li
                      value={mail}
                      key={index}
                      onClick={() => {
                        handleExistingSubOnChange(index);
                      }}
                    >
                      <div
                        className="subsItem"
                        id={`custom-checkbox-Item-${index}`}
                      >
                        <label
                          htmlFor={`custom-checkbox-${index}`}
                          className="subsLabel"
                        >
                          {mail.email}
                        </label>
                        <input
                          type="checkbox"
                          id={`custom-checkbox-${index}`}
                          name={mail.email}
                          value={mail.email}
                          checked={checkedState[index]}
                        />
                      </div>
                    </li>
                  ))}
                </div>
              )}
            </ul>
          </>
        ) : null}
      </div>
    </div>
  );
}

export default SubscriberDropDown;
